import React from 'react';
import ReactDOM from 'react-dom';
// import getMuiTheme from 'material-ui/styles/getMuiTheme'; // (new v0.15.0 import path)
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import injectTapEventPlugin from 'react-tap-event-plugin'
// import { Router, Route, Link, hashHistory } from 'react-router'
import './index.css';
// import App from './App.js';
import ReactRouterV4 from './ReactRouterV4.js'
import AppBar from './components/AppBar';
import muiTheme from './components/ppappTheme'
import urlParam from './urlParam'

injectTapEventPlugin();
// import { Button } from 'semantic-ui-react'
// const muiTheme = getMuiTheme({
//   appBar: {
//     height: 48, // Instead of 64
//   }
// });


ReactDOM.render(
  <MuiThemeProvider muiTheme={muiTheme}>
    <div style={{ display: 'flex', flexFlow: 'column', height: '100%' }}>
      {
        urlParam.app === 'true' ? null :
          <AppBar />
      }
      <ReactRouterV4 />
    </div>
  </MuiThemeProvider>
  ,
  document.getElementById('root')
);

/*ReactDOM.render(
<App />,
  document.getElementById('root'));*/


// WEBPACK FOOTER //
// ./src/index.js